<div class="tw-flex tw-flex-wrap tw-gap-4">
  <div class="upload-file">
    <div class="button"
      (click)="onOpenFileExplorer()">
      <input class="tw-hidden" id="file" type="file" (change)="onChangeFile($event)">
      <i nz-icon nzType="plus" nzTheme="outline" class="tw-text-lg"></i>
      <span class="text-info mt-xxs">
        Agregar imagen
      </span>
    </div>
  </div>
  <div class="file-list" *ngFor="let file of files; index as i">
    <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="icon-action danger" (click)="onDeleteFile(file._id, i)">
      <i nz-icon nzType="delete" nzTheme="outline"></i>
    </div>
    <img class="img" *ngIf="!this.loadingImage[i] && file.transformations && file.transformations.lenght !== 0 && !file.path"  [src]="file.transformations[0].secureUrl" alt="" (click)="onClickFile(i)">
    <img class="img" *ngIf="!this.loadingImage[i] && file.path" nz-image [nzSrc]="file.path" alt="">

    <img id="fullImage{{i}}" *ngIf="!this.loadingImage[i] && file.transformations && file.transformations.lenght !== 0" nz-image [nzSrc]="file.transformations[2].secureUrl" alt="" class="tw-hidden">

    <div *ngIf="this.loadingImage[i]" class="tw-flex tw-flex-col">
      <i class="text-info tw-text-lg" nz-icon nzType="loading" nzTheme="outline"></i>
      <p class="text-info mt-xxs">Guardando archivo...</p>
    </div>
  </div>
</div>



<ng-template #tplModalDelete>
  <p class="tw-mt-4 text-info">
    ¿Seguro que deseas eliminar la imagen?
  </p>
</ng-template>
